<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title nowrap"><i class="fas fa-plane-arrival m-r-5"></i> Llegadas programadas
            <span class="f-s-13">(Total {{total_pax}} pax)</span></h4>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-8 col-md-8 col-sm-8 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm m-b-5" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
              <div class="content__subhead__inputGrid m-b-5">
                <div class="input-group" style="width: 105%;">
                  <span class="input-group-prepend">
                    <span class="input-group-text content__subhead__inputGrid__title">
                      <i class="far fa-calendar-alt"></i>
                    </span>
                  </span>
                  <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
                </div>
              </div>
              <a target="_blank"
                href="/{{branchofficeSlug}}/api/arrivals/export/{{start_range.format('YYYY-MM-DD')}}/{{end_range.format('YYYY-MM-DD')}}"
                class="btn btn-sm btn-light m-b-5" title="Exportar">
                <span class="hide-xs">Exportar</span> <i class="far fa-file-pdf f-s-14 text-danger"></i>
              </a>
              <span class="bold"><i class="fas fa-info-circle parpadea m-l-15"></i>
                LLEGAN HOY</span>
              <span class="bold nowrap"><i class="fas fa-check-circle text-orange m-l-15 m-r-2"></i>Recojo
                Programado</span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <ng-container *ngIf="items.length > 0">
            <div class="m-b-5" *ngFor="let date of getKeys(groupedBookings)">
              <div class="col-lg-12 col-12 p-l-5">
                <h3 class="bold f-s-13 text-primary">
                  <span *ngIf="date_now == date">HOY</span>
                  <span *ngIf="date_now != date">FECHA LLEGADA </span>
                  : {{ date }} <span class="text-dark">( {{groupedBookings[date].totalNroPax}} pax)</span>
                  <a href="/{{branchofficeSlug}}/api/arrivals/export/{{date}}/{{date}}"
                    class="btn btn-small btn-default f-s-13" target="_blank" style="padding: 3px 9px;"><i
                      class="far fa-file-pdf text-danger"></i> </a>
                  <span class="f-s-9 m-l-10">.................................................</span>
                </h3>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-lg-3 col-md-6 col-sm-6 col-12 p-5"
                    *ngFor="let data of groupedBookings[date].bookings">
                    <div class="card group__item m-b-15"
                      [ngClass]="{'boder-left-orange-broad': data.is_scheduled_pickup }">
                      <div class="card-header group__item__header p-5">
                        <div class="flex p-0">
                          <div class="flex-60 group__item__header__code pointer" (click)="detailBookingExtends(data)"
                            data-toggle="modal" data-target="#openBookingsExtends">
                            <span class="grid__link" style="font-weight: bold;">{{data.code}}</span>
                            <i class="far fa-window-maximize m-l-3"></i>
                          </div>
                          <div class="flex-40 text-right">
                            <span class="badge badge-light f-s-11">
                              <i *ngIf="date_now == date" class="fas fa-info-circle parpadea"></i>
                              {{data.date_arrival}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="card-body group__item__body p-10">
                        <div class="group__item__body__item f-s-12 m-b-5">
                          <div class="btn btn-small btn-default m-l-5 f-s-14"
                            style="padding: 3px 9px; position: absolute; right: 5px; top: 35px;"
                            (click)="copyToClipboard(data.id)" data-toggle="tooltip" data-placement="right"
                            data-original-title="Clic para copiar">
                            <i class="far fa-copy"></i>
                          </div>
                          <p class="bold m-b-0" *ngIf="data.is_book_hotel">
                            <i class="fas fa-hotel m-r-5"></i>
                            <span class="badge badge-hotel f-s-10">RESERVA SOLO HOTEL</span>
                          </p>
                          <p class="bold m-b-0">Hora :
                            {{data.time_arrival}}</p>
                          <p class="group__item__body__item">
                            <i class="fas fa-plane-arrival m-r-5 "></i>
                            <ng-container *ngIf="data.arrivalplace_id != null">
                              <span class="f-s-10 text-uppercase bold">{{data.arrivalplace_data.description}}</span>
                            </ng-container>
                            <ng-container *ngIf="data.arrival_place != null">
                              <span class="f-s-10 m-l-5">: {{data.arrival_place}}</span>
                            </ng-container>
                            <ng-container *ngIf="data.arrival_place == null">
                              <span class="f-s-9 m-l-5">No especifica datos.</span>
                            </ng-container>
                          </p>
                        </div>
                        <div class="group__item__body__item f-s-12">
                          <span class="f-s-11" style=" display: block;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;"><i
                              class="fas fa-user-tie m-r-5 "></i>{{data.client_data.fullname}}</span>
                          <p class="bold f-s-10 m-b-0">{{data.client_data.typeDocument}} :
                            {{data.client_data.document}} <span class="f-s-10 m-l-2">({{data.nro_pax}} pax)</span>
                          </p>
                        </div>
                        <div class="group__item__body__item f-s-11 bold">
                          <i class="fas fa-phone m-r-5"></i>
                          {{data.client_data.cellphone}}
                          <span class="m-l-5" *ngIf="data.client_data.telephone != null">
                            {{data.client_data.telephone}}
                          </span>
                        </div>
                        <div class="group__item__body__item f-s-12">
                          <i class="fas fa-map-pin m-r-5 "></i>
                          <ng-container *ngIf="data.reference_location != null">
                            {{data.reference_location}}
                          </ng-container>
                          <ng-container *ngIf="data.reference_location == null">
                            ---
                          </ng-container>
                        </div>
                        <div class="group__item__body__item f-s-12">
                          <i class="fas fa-tag m-r-5 "></i>
                          <span class="f-s-10">{{data.reference_voucher}}</span>
                          <div *ngIf="data.workinggroup_id != null" style="margin-left: 15px; margin-top: -5px; ">
                            <span class="badge badge-dark f-s-8"
                              style="background-color: #8599b1;">{{data.workinggroup_data.description}}</span>
                          </div>
                        </div>
                        <ng-container *ngIf="data.arrivalplace_id != arrival_cuentapropia.id">
                          <ng-container *ngIf="!data.is_scheduled_pickup">
                            <div class="group__item__body__item f-s-12 text-left m-t-7">
                              <i class="fas fa-car-alt m-r-5"></i>COORDINAR RECOJO
                              <p class="bold f-s-10 m-b-0 m-t-5 d-flex" style="justify-content: center;">
                                <button (click)="pickupHotel(data)" class="btn btn-info btn-sm f-s-9 bold m-r-10"
                                  style="padding: 3px 5px;">Asignar Hotel</button>
                                <button (click)="pickupCollaborator(data)" data-toggle="modal"
                                  data-target="#openExtendsSelectCollaborators" class="btn btn-dark btn-sm f-s-9 bold"
                                  style="padding: 3px 5px;">Asignar Colab.</button>
                              </p>
                            </div>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="data.arrivalplace_id == arrival_cuentapropia.id">
                          <span class="bold text-center d-block m-t-10">Llegada a cuenta propia</span>
                        </ng-container>
                        <ng-container *ngIf="data.is_scheduled_pickup">
                          <div class="group__item__body__item f-s-12 text-center m-t-7">
                            <span class="bold">
                              <i class="fas fa-check-circle m-r-2 text-orange f-s-14"></i> <i
                                class="fas fa-car-alt m-r-5 f-s-13"></i>RECOJO PROGRAMADO
                              <button (click)="resetPickup(data)" class="btn btn-small btn-default m-l-5 f-s-8"
                                style="padding: 3px 9px;"><i class="fas fa-undo"></i></button>
                            </span>
                            <div class="m-t-5">
                              <ng-container *ngIf="data.is_pickup_hotel">
                                <span class="badge badge-info f-s-11">SE ASIGNÓ AL HOTEL</span>
                              </ng-container>
                              <ng-container *ngIf="data.is_pickup_collaborator">
                                <span class="badge badge-dark f-s-11">
                                  {{data.pickup_collaborator_data.fullname}}
                                  <span class="f-s-9">/ ({{data.pickup_collaborator_data.cellphone}})</span>
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <div id="generated-data-{{data.id}}"
                        style="height: 0; margin: 0;  background: transparent; z-index: 0; color: transparent;">
                        <p>**** *RECOJO CONFIRMADO*</p>
                        <div>*RESPONSABLE* : {{data.client_data.fullname}}</div>
                        <div>*CEL* : {{data.client_data.cellphone}}
                          <span *ngIf="data.client_data.telephone != null">/ {{data.client_data.telephone}}</span>
                        </div>
                        <div>*PAX* : {{data.nro_pax}}</div>
                        <div>*FECHA* : {{data.date_arrival}}</div>
                        <div>*HORA* : {{data.time_arrival}}</div>
                        <div>
                          <i class="fas fa-plane-arrival m-r-5 "></i>
                          <ng-container *ngIf="data.arrivalplace_id != null">
                            <span class="f-s-10 text-uppercase bold">*{{data.arrivalplace_data.description}}*</span>
                          </ng-container>
                          <ng-container *ngIf="data.arrival_place != null">
                            <span class="f-s-10 m-l-5">: {{data.arrival_place}}</span>
                          </ng-container>
                          <ng-container *ngIf="data.arrival_place == null">
                            <span class="f-s-9 m-l-5">: No especifica datos.</span>
                          </ng-container>
                        </div>
                        <div>
                          *DESTINO* :
                          <ng-container *ngIf="data.reference_location != null">
                            {{data.reference_location}}
                          </ng-container>
                          <ng-container *ngIf="data.reference_location == null">
                            No especifica
                          </ng-container>
                        </div>
                        <p>...</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>
          <div *ngIf="items.length == 0" class="col-12 text-center p-t-50">
            <i class="fas fa-plane-arrival f-s-50"></i>
            <p class="m-t-10 f-s-20">No se encontraron llegadas.</p>
          </div>
        </div>

        <!-- <div class="container mt-5">
          <h2>Generated Data</h2>
          <div id="generated-data" >
            <div>*Name*: John Doe</div>
            <div>*Email*:john.doe@example.com</div>
            <p><strong>*Phone*:</strong> +1234567890</p>
            <div><strong>*casa*:</strong> LAS PALMAS</div>
          </div>
          <div class="mt-3">
            <button class="btn btn-primary" (click)="copyToClipboard()">Copy to Clipboard</button>
          </div>
        </div> -->


      </div>
    </div>
  </div>
</div>

<app-collaborators-select-extends (onSubmitEvent)="selectedCollaborator($event)"></app-collaborators-select-extends>
<app-bookings-extends (onSubmitEvent)="afterBookingDetail($event)"></app-bookings-extends>
